import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import { ToolUserClaims } from '../../../authentication/ToolUserClaims';
import { ToolAuthorisationClaimsContext } from '../../../authentication/ToolAuthorisationClaimsContext';
import { ProjectTheme } from '@yakoffice/project-theme';
import { BuildsContainer } from './buildsContainer';

export const BuildsIndex: FC = () => {

    const { projectId } = useParams<{ projectId: string }>();
    const authUser = useAuthUser();
    const isMiniclipPublicUser: boolean = !authUser || !authUser.isAuthorisedForHostedToolProject(projectId);

    return (
        <ToolAuthorisationClaimsContext.Provider value={new ToolUserClaims(authUser, projectId, isMiniclipPublicUser)}>
            <ProjectTheme>
                <BuildsContainer />
            </ProjectTheme>
        </ToolAuthorisationClaimsContext.Provider>
    );
};
